import { Patient } from './Patient';
import { ProjectViewData } from './ProjectViewData';

export class Project {
  pid: number;
  uuid: string;
  upload_file_name: string;
  upload_num: number;
  is_done: boolean = false;
  created_at: string;
  syncPercentage: number;
  syncComplete: boolean = false;
  upload_numAll: number = 0;
  medcat_numAll: number = 0;
  convert_numAll: number = 0;
  validate_numAll: number = 0;
  to_a_numAll: number = 0;
  to_b_numAll: number = 0;
  codeResult: boolean = false;
  visualResult: boolean = false;
  syncError: boolean = false;
  projectView: ProjectViewData[] = [];
  patients: Patient[];
}
